import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  // support = null (checking) | true (active support session) | false (none)
  const [support, setSupport] = useState(null);

  useEffect(() => {
    let alive = true;
    if (user) { setSupport(false); return; }        // normal customer login wins
    if (user === null) return;                        // still loading customer auth
    // guest: could still be a super-admin support session (HttpOnly cookie)
    api.get("/support/session").then(({ data }) => { if (alive) setSupport(!!data.active); })
      .catch(() => { if (alive) setSupport(false); });
    return () => { alive = false; };
  }, [user]);

  if (user === null || (!user && support === null)) {
    return (
      <div className="dark flex min-h-screen items-center justify-center bg-fundio-dark">
        <Loader2 className="h-8 w-8 animate-spin text-fundio-gold" />
      </div>
    );
  }
  if (user || support) return children;
  return <Navigate to="/login" replace />;
}
